import React from 'react';
import { ClockIcon } from 'lucide-react';
import { eventHours, weekends } from '../data/event';
export function WeekendSchedule() {
  return <div data-id="element-198" data-mp="19w5sh45lypwa">
      <ol className="divide-y divide-line" data-id="element-199" data-mp="19vchts3j3g8v">
        {weekends.map((w, i) => <li key={w.dates} className="flex items-center gap-4 py-4 first:pt-0" data-id="element-200" data-mp="15wdhylwnm9oa" data-mpi={i}>
            <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full font-display text-lg font-bold ${i === 0 ? 'bg-orange-deep text-white' : 'bg-navy-light text-navy'}`} aria-hidden="true" data-id="element-201" data-mp="10y24m175hh1b">
              {i + 1}
            </span>
            <div className="min-w-0" data-id="element-202" data-mp="1oofylx9appyj">
              <p className="font-display text-xl font-semibold uppercase leading-tight text-ink" data-id="element-203" data-mp="1jns06qiqm6ua">{w.dates}</p>
              <p className="text-sm text-muted" data-id="element-204" data-mp="d7g8976idl75">{w.label} · {w.days}</p>
            </div>
          </li>)}
      </ol>
      <p className="mt-2 flex items-center gap-2 rounded-lg bg-canvas px-4 py-3 text-sm font-medium text-ink" data-id="element-205" data-mp="87bnh4yki4b4">
        <ClockIcon className="h-4 w-4 text-navy" aria-hidden="true" data-id="element-206" data-mp="2hotvvheubdrj" />
        Open every Friday, Saturday & Sunday, {eventHours}
      </p>
    </div>;
}